/**
 * @desc updateOrderStatus
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationUpdateOrderStatusDto, options?: any) {
  return updateResponse(
    http(URL + `/allocation/updateOrderStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
